import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import router from '../main.js'

axios.defaults.timeout = 600000;
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
axios.defaults.baseURL = 'http://admin.brlsea.org';
let token = '';
let that = this;
let url = encodeURIComponent('');
Vue.prototype.$axios = axios;

axios.interceptors.request.use((config) => {
	return config;
}, (error) => {
	return Promise.reject(error);
});

export const getSiteConfig = params => { //获取网站基础设置
	return axios.get(`/api/index/getSiteConfig`, {params}).then(res => res.data);
};
export const getIndex = params => { //获取首页板块
	return axios.get(`/api/index/getIndex`, {params}).then(res => res.data);
};
export const getBottom = params => { //获取底部版块
	return axios.get(`/api/index/getBottom`, {params}).then(res => res.data);
};
export const getMember = params => { // 获取会员风采
	return axios.get(`/api/index/getMember`, {params}).then(res => res.data);
};
export const getArticle = params => { //获取文章列表
	return axios.get(`/api/index/getArticle`, {params}).then(res => res.data);
};
export const getArticleDetail = params => { //获取文章详情
	return axios.get(`/api/index/getArticleDetail`, {params}).then(res => res.data);
};
export const addContactUs = params => { //提交联系我们信息
	return axios.post(`/api/index/addContactUs`, params).then(res => res.data);
};
export const getArticleComment = params => { //获取文章评论
	return axios.post(`/api/index/getArticleComment`, params).then(res => res.data);
};
export const addArticleComment = params => { //提交文章评论
	return axios.post(`/api/index/addArticleComment`, params).then(res => res.data);
};
export const getFeedback = params => { //获取已提交的意见
	return axios.post(`/api/index/getFeedback`, params).then(res => res.data);
};
export const delFeedback = params => { //删除已提交的意见
	return axios.get(`/api/index/delFeedback`, {params}).then(res => res.data);
};
export const checkFeedbackStatus = params => { //检查是否已提交网站意见
	return axios.post(`/api/index/checkFeedbackStatus`, params).then(res => res.data);
};
export const getActivity = params => { //获取活动日历
	return axios.get(`/api/index/getActivity`, {params}).then(res => res.data);
};
export const getTopic = params => { //获取意见调查题目
	return axios.get(`/api/index/getTopic`, {params}).then(res => res.data);
};
export const addTopicLog = params => { //提交问卷
	return axios.get(`/api/index/addTopicLog`, {params}).then(res => res.data);
};
export const getNav = params => { //获取导航栏
	return axios.get(`/api/index/getNav`, {params}).then(res => res.data);
};
export const getArticleCategory = params => { //获取标准化分类
	return axios.get(`/api/index/getArticleCategory`, {params}).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/api.js